import React, { useEffect, useState } from 'react';
import './Attendees.css'
import Sidebar from '../Components/Layout/Sidebar';
import { Header } from '../Components/Layout/Header';
import PageTitle from '../Components/Common/PageTitle';
import StatCard from '../Components/Common/StatCard';

import Users from '../Assets/Icons/Users2.svg'
import Checked from '../Assets/Icons/Checked.svg'
import Sv from '../Assets/Icons/Supervisors.svg'
import UsersTable from '../Components/Layout/UsersTable';
import { supabase } from '../supabase';

const Attendees = () => {

    const [users, setUsers] = useState([]);
    
        useEffect(() => {
            const getUsers = async () => {
                const res = await supabase.from("users").select('*')
                setUsers(res.data)
            }
    
            getUsers();
        } , [])

    return ( 
        <main className='Attendees'>
            <Sidebar />

            <div className='MainContent'>
                <Header />

                <div className='PageCards'>
                    <PageTitle TitleText='User Management' SubText='Monitor and manage all users registered for the EVS Electrify Egypt Exhibiton' HeaderBtnsClass='NoHeaderBtns'/>

                    <section className='StatCards'>
                        <StatCard SCardLabel="TOTAL USERS" SCardValue={users.length} SCardIcon={Users}/>
                        <StatCard SCardLabel="ACTIVE NOW" SCardValue={users.filter(user => user.status === 'Active').length} SCardIcon={Checked}/>
                        <StatCard SCardLabel="CURRENT SUPERVISORS" SCardValue='4' SCardIcon={Sv}/>
                    </section>

                    <div className='Activity'>
                        <UsersTable />
                    </div>

                    
                </div>
            </div>
        </main>
     );
}
 
export default Attendees;